import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router';
import { Button, Col, Select, Drawer, Form, Input, Row, Switch, Space, message, InputNumber, Flex, Mentions, Divider  } from 'antd';
import { CloseOutlined, CheckOutlined, MoonFilled, SunFilled } from '@ant-design/icons';
import {getById, insert, update, test} from '../../../../apis/FormulaApi';
import Editor from '@monaco-editor/react';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import { defFunction, declareFuncionInicio, declareFuncionFin, codeInit} from '@app/constants/definition_python';
import {getEmpleados} from '../../../../apis/OdooApi';
import {procesarNomina, procesarNominaEmpleado} from '../../../../apis/ProcesoNominaApi';

const { Option } = Select;
const App = ({title, id, open, finish}) => {
    const [ form] = Form.useForm()
    const [ formTest ] = Form.useForm()
    const { conceptId } = useParams();
    const [ID, setID] = useState(id);
    const [code, setCode] = useState(codeInit);
    const [showModal, setShowModal] = useState(false);
    const [modified, setModified] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [themeEditor, setThemeEditor] = useState('light');
    const [resultadoTest, setResultadoTest] = useState('');
    const [empleados, setEmpleados] = useState([]);

    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getEmpleadosOdoo();
            })();
        }
        return () => effectRan.current = true;
    }, []);

    const getEmpleadosOdoo = async ()=>{
        const response = await getEmpleados();
        if(response.ok){
            let items = response.payload;
            setEmpleados(items);
        }
    }

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        let success = false;
        let formula = editorRef.current.getValue();
        if(ID > 0){
            //Update
            const payload = {
                id: ID,
                concepto_id: conceptId,
                ...fields,
                formula: formula
            }
            const response = await update(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se actualizó correctamente la formula!');
                setModified(true);
            }
        }else{
            //Create
            const payload = {
                id: ID,
                concepto_id: conceptId,
                ...fields,
                formula: formula
            }
            const response = await insert(payload);
            success = response.ok;
            if(response.ok){
                setID(response.payload);
                message.success('Se guardo correctamente la formula!');
                setModified(true);
            }
        }
         
        if(success){
            //setShowModal(false);
            //finish(true);
        }
    }

    const onClose = (reload)=>{
        finish(reload ?? modified);
        setInitialValues(null);
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                //await refreshVariables();
                if(ID > 0){
                    await refreshData();
                }else{
                    setInitialValues({
                        concepto_id: null,
                        activo: true,
                        formula: codeInit
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);
    
    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    const refreshData = async ()=> {
        const response = await getById(ID);
        if(response.ok){
            let payload = response.payload;
            setInitialValues(payload);
            setCode(payload.formula)
        }
    }

    const editorRef = useRef(null);

    // function handleEditorChange(editor, monaco) {
    //     editorRef.current = editor;
    // }

    function handleEditorDidMount(editor, monaco) {
        editorRef.current = editor;
    }

    function getName(){
        const fields = form.getFieldsValue()
        let newName = fields.descripcion.replaceAll(" ", "_");
        return newName;
    }

    const onChangeName = async () => {
        let newName = getName();
        let currentCode = editorRef.current.getValue();
        let newDefFunction = 'def '+newName+'():';
        let currentDefinition =  (currentCode.split(declareFuncionInicio)[1] || "").split(declareFuncionFin)[0];
        if(currentDefinition == defFunction){
            currentCode = currentCode.replace(currentDefinition, `${declareFuncionInicio}\n${newDefFunction}\n${declareFuncionFin}`) 
        }else{
            currentCode = currentCode.replace(currentDefinition, `\n${newDefFunction}\n`)
        }
        editorRef.current.getModel().setValue(currentCode);
        // setCode(currentCode);
    }

    const onChangeTheme = async (value) => {
        setThemeEditor(value?'light':'vs-dark');
    }

    const handleTestOk = async () =>{
        let success = false;
        const fields = formTest.getFieldsValue()
        //Test
        let functionName = getName();
        const payload = {
            formula_id: ID,
            function_name: functionName,
            ...fields
        }
        const response = await test(payload);
        success = response.ok;
        if(response.ok){
            // setID(response.payload);
            setResultadoTest(response.payload);
        }
    }

    const handleProcesarOk = async () =>{
        let success = false;
        const fields = formTest.getFieldsValue()
        //Test
        let functionName = getName();
        const payload = {
            formula_id: ID,
            function_name: functionName,
            ...fields
        }
        const response = await procesarNominaEmpleado(payload);
        success = response.ok;
        if(response.ok){
            // setID(response.payload);
            setResultadoTest(response.payload);
        }
        
    }

    return (
        <Drawer
            title={title}
            width={'100%'}
            placement={"right"}
            onClose={onClose}
            open={true}
            closable={true}
            extra={[
            <Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>]}
        >
            <>
            {
                initialValues && 
                <Form 
                    layout="vertical" 
                    form={form} 
                    requiredMark 
                    autoComplete="off"
                    initialValues={initialValues} 
                    onFinish={handleOk}>
                        <Row gutter={16}>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="descripcion"
                                    label="Descripción"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega una descripción',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega una descripción"/>
                                </Form.Item>
                            </Col>
                            {/* <Col md={{span: 24}} sm={{span: 24}} xs={{span: 24}}>
                                <Form.Item
                                    name="formula"
                                    label="Formula"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega una formula, tu puedes usar @ para ver las variables disponibles',
                                    },
                                    ]}
                                >
                                    <Mentions options={variables} allowClear rows={1} autoSize/>
                                </Form.Item>
                            </Col> */}
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="activo"
                                    label="Activo"
                                    >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}} style={{marginBottom: 20, marginLeft: 20}}>
                                Color del editor
                                <Switch defaultChecked checkedChildren={<SunFilled />} unCheckedChildren={<MoonFilled />} onChange={onChangeTheme} style={{marginLeft: 20}}/>
                            </Col>
                        </Row>
                        <Editor
                            width={'100%'}
                            height="90vh"
                            defaultLanguage="python"
                            defaultValue={initialValues.formula}
                            theme={themeEditor}
                            options={{
                                inlineSuggest: true,
                                fontSize: "16px",
                                formatOnType: true,
                                autoClosingBrackets: true,
                                minimap: { scale: 10 }
                            }}
                            onMount={handleEditorDidMount}
                            />
                        
                            {/*
                                ID > 0 && <>
                                <Divider orientation="left">Prueba</Divider>
                                <Form 
                                    layout="vertical" 
                                    form={formTest} 
                                    requiredMark 
                                    autoComplete="off" 
                                    onFinish={handleTestOk}>
                                    <AnioPeriodo form={formTest} disabledForm={false}/>
                                    <br/>
                                    <Flex wrap gap="large">
                                        <Form.Item
                                            name="empleado_id"
                                            label="Empleado"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Selecciona un empleado',
                                            },
                                            ]}
                                        >
                                                <Select placeholder="Por favor selecciona un empleado">
                                                {
                                                    empleados.map((item)=><Option value={item.value}>{item.text}</Option>)
                                                }
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            name="salario_diario"
                                            label="Salario Diario"
                                        >
                                            <InputNumber />
                                        </Form.Item>
                                        <Form.Item
                                            name="dias_trabajados"
                                            label="Dias Trabajados"
                                        >
                                            <InputNumber />
                                        </Form.Item>
                                        <Form.Item
                                            name="horas_trabajadas"
                                            label="Horas Trabajados"
                                        >
                                            <InputNumber />
                                        </Form.Item>
                                    </Flex>
                                    <br/>
                                    <Form.Item>
                                        <Space>
                                            <Button onClick={handleTestOk} type='primary'>
                                                Probar
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                    <br/>
                                    <Form.Item>
                                        <Space>
                                            Resultado: {resultadoTest}
                                        </Space>
                                    </Form.Item>
                                    <br/>
                                    <Form.Item>
                                        <Space>
                                            <Button onClick={handleProcesarOk} type='primary'>
                                                Procesar
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                    <br/>
                                    <Form.Item>
                                        <Space>
                                            Resultado: {resultadoTest}
                                        </Space>
                                    </Form.Item>
                                </Form>
                                </>
                            */
                            }
                </Form>
            }
            </>
        </Drawer>
    );
};
export default App;